module.exports = __webpack_public_path__ + "img/symbol_2.b6fac0b9.png";